import { render, staticRenderFns } from "./StcvD_Details.vue?vue&type=template&id=2c1e4d77"
import script from "./StcvD_Details.vue?vue&type=script&lang=js"
export * from "./StcvD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports